import * as React from "react"
import { useParams, useOutletContext } from "react-router-dom"
import FilesGridTools from "../../../../files/components/FilesGrid/FilesGridTools/FilesGridTools"
import FilesGrid from "../../../../files/components/FilesGrid/FilesGrid"
import TrackerHeader from "components/WorkflowTracker/TrackerHeader/TrackerHeader"
import RequestFaveButton from "containers/requests/Request/RequestFaveButton/RequestFaveButton"
import "./RequestFiles.scss"

// api
import { useGetRequest } from "api/hooks/requests/useRequestsApi"

const RequestFiles = () => {
  const { requestId } = useParams()

  // server state
  const { data: request } = useGetRequest(requestId)

  // local state
  const { onOpenPanel, breadcrumbsData, requestFiles, setAddFilesModalOpen } = useOutletContext()
  const [search, setSearch] = React.useState("")

  const onSelectionChanged = ({ api }) => {
    const selectedNodeData = api.getSelectedNodes().map((node) => node.data)
    console.log("Bulk remove files from request", selectedNodeData)
  }

  return (
    <>
      <TrackerHeader
        model="request"
        title={request?.request_id}
        status={request?.status}
        breadcrumbs={breadcrumbsData}
        workflowId={request?.workflow_id}
        workflowObj={request}
        onOpenPanel={onOpenPanel}
        showWorkFlowActions={false}
        actions={[<RequestFaveButton request={request} />]}
      />
      <div className="request-files-tab">
        <FilesGridTools
          setSearch={setSearch}
          setAddFilesModalOpen={setAddFilesModalOpen}
        />
        <FilesGrid
          rowData={requestFiles}
          search={search}
          // selectableColumn={{ headerCheckboxSelection: true }} // TODO: uncomment when implemnt bulk editing
          rowMultiSelectWithClick={true}
          onSelectionChanged={onSelectionChanged}
        />
      </div>
    </>
  )
}

export default RequestFiles
